"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("./styles.css");

var _VerticalLine = _interopRequireDefault(require("./VerticalLine"));

var _VerticalLineExtended = _interopRequireDefault(require("./VerticalLineExtended"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AssembleGridRule = function AssembleGridRule(_ref) {
  var columnRangeType = _ref.columnRangeType,
      startDatetime = _ref.startDatetime,
      columnQuantity = _ref.columnQuantity,
      columnSections = _ref.columnSections,
      extended = _ref.extended,
      scrollable = _ref.scrollable,
      onDivisionSummary = _ref.onDivisionSummary;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "App"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "space"
  }), scrollable ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "square-container scroll-test-traffic-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "square"
  }, extended ? /*#__PURE__*/_react["default"].createElement(_VerticalLineExtended["default"], {
    columnSections: columnSections,
    columnQuantity: columnQuantity,
    startDatetime: startDatetime,
    columnRangeType: columnRangeType,
    onDivisionSummary: onDivisionSummary
  }) : /*#__PURE__*/_react["default"].createElement(_VerticalLine["default"], {
    columnSections: columnSections,
    columnQuantity: columnQuantity,
    startDatetime: startDatetime,
    columnRangeType: columnRangeType,
    onDivisionSummary: onDivisionSummary
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "square"
  }, extended ? /*#__PURE__*/_react["default"].createElement(_VerticalLineExtended["default"], {
    columnSections: columnSections,
    columnQuantity: columnQuantity,
    startDatetime: startDatetime,
    columnRangeType: columnRangeType,
    onDivisionSummary: onDivisionSummary
  }) : /*#__PURE__*/_react["default"].createElement(_VerticalLine["default"], {
    columnSections: columnSections,
    columnQuantity: columnQuantity,
    startDatetime: startDatetime,
    columnRangeType: columnRangeType,
    onDivisionSummary: onDivisionSummary
  })));
};

var _default = AssembleGridRule;
exports["default"] = _default;